import styled from '@emotion/styled';

export const StakesSportRow = styled('div', { label: 'StakesSportRow' })`
    display: flex;
    align-items: center;
`;
